import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "short" }) : "-");
const ACT = { PENEMPATAN_AWAL: "Penempatan awal", PEMINDAHAN: "Pemindahan" };

export function HistoryList({ items, testid = "placement-history" }) {
  if (!items) return <p className="text-xs text-[#6B7280]">Memuat…</p>;
  if (!items.length) return <p className="text-xs text-[#6B7280]" data-testid={`${testid}-empty`}>Belum ada riwayat.</p>;
  return (
    <div className="max-h-80 divide-y overflow-y-auto rounded border border-[#E5E7EB] text-xs" data-testid={testid}>
      {items.map((h) => (
        <div key={h.id} className="p-2" data-testid={`${testid}-row-${h.id}`}>
          <div className="flex justify-between gap-2">
            <span className="font-semibold">{h.customer_id} · {h.nama_customer || "-"}</span>
            <span className={h.active ? "font-semibold text-[#16A34A]" : "text-[#6B7280]"}>{h.active ? "Aktif" : "Selesai"}</span>
          </div>
          <div>{ACT[h.action] || h.action}: {h.prev_odp_kode ? `${h.prev_odp_kode}:${h.prev_port} → ` : ""}<b>{h.odp_kode}:{h.port}</b></div>
          <div className="text-[#6B7280]">Mulai {fmt(h.started_at)} oleh {h.started_by}
            {h.ended_at && <> · Selesai {fmt(h.ended_at)} oleh {h.ended_by} ({h.end_reason})</>}</div>
          {h.catatan && <div className="text-[#6B7280]">Catatan: {h.catatan}</div>}
        </div>
      ))}
    </div>
  );
}

export function HistoryDialog({ odp, onClose }) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    if (odp) api.get("/network/placements/history", { params: { odp_id: odp.id } }).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [odp]);
  return (
    <Dialog open={!!odp} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-lg" data-testid="history-dialog">
        <DialogHeader><DialogTitle>Riwayat Penempatan {odp?.kode}</DialogTitle></DialogHeader>
        <HistoryList items={items} />
      </DialogContent>
    </Dialog>
  );
}
